import { Component, inject, OnInit, Signal } from '@angular/core';
import { BreadcrumbsComponent } from '../../../../common/breadcrumbs/breadcrumbs.component';
import { ContentComponent } from '../../../../components/content/content.component';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { Store } from '@ngrx/store';
import {
  selectAreaItemById,
  selectLoading,
  selectPending, selectScheduleCollection
} from '../../../../store/selectors/municipal-waste.selectors';
import { loadCollection, loadScheduleEntries } from '../../../../store/actions/municipal-waste.actions';
import { SpinnerComponent } from '../../../../common/spinner/spinner.component';
import {
  WasteCollectionAreaAppEntityWasteWasteCollectionAreaRead,
  WasteCollectionScheduleEntryAppEntityWasteWasteCollectionScheduleEntryRead
} from '../../../../openapi';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-municipal-waste-harmonogram-page',
  standalone: true,
  imports: [
    BreadcrumbsComponent,
    ContentComponent,
    RouterLink,
    SpinnerComponent,
    DatePipe
  ],
  templateUrl: './municipal-waste-harmonogram-page.component.html'
})
export class MunicipalWasteHarmonogramPageComponent implements OnInit {

  private store$: Store = inject(Store);

  private route: ActivatedRoute = inject(ActivatedRoute);

  private areaId: string = this.route.snapshot.params['areaId'];

  public area: Signal<WasteCollectionAreaAppEntityWasteWasteCollectionAreaRead | null> = this.store$.selectSignal(selectAreaItemById(this.areaId));

  public scheduleCollection: Signal<WasteCollectionScheduleEntryAppEntityWasteWasteCollectionScheduleEntryRead[]> = this.store$.selectSignal(selectScheduleCollection);

  public pending: Signal<boolean> = this.store$.selectSignal(selectPending);

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  public ngOnInit(): void {
    this.store$.dispatch(loadCollection({}));
    this.store$.dispatch(loadScheduleEntries({ areaId: this.areaId }));
  }
}
